import { api } from "lib"

export const getEmployeeRequestCalendar = async (params) => {
    return await api.post("/v1/employee/getEmployeeRequestCalendar", params)
}